import { useState, useCallback } from 'react';
import {
  transition,
  getInitialLoginState,
  type LoginState,
  type LoginEvent,
  type TransitionResult,
} from '../services/loginStateMachine';

export interface UseLoginStateMachineResult {
  state: LoginState;
  dispatch: (event: LoginEvent) => TransitionResult;
  reset: () => void;
}

export function useLoginStateMachine(): UseLoginStateMachineResult {
  const [state, setState] = useState<LoginState>(getInitialLoginState);

  const dispatch = useCallback((event: LoginEvent): TransitionResult => {
    const result = transition(state, event);
    setState(result.nextState);
    return result;
  }, [state]);

  const reset = useCallback((): void => {
    setState(getInitialLoginState());
  }, []);

  return { state, dispatch, reset };
}
